import * as React from 'react';
import { useLocation } from 'react-router';

import analytics from '../services/analytics';
import { signInToAmp } from './signInToAmp';

const UserAuthenticationState = ({
  isAuthenticatedToBackend,
  setIsAuthenticatedToBackend
}: {
  isAuthenticatedToBackend: boolean;
  setIsAuthenticatedToBackend: (isAuthenticatedToBackend: boolean) => void;
}) => {
  React.useEffect(() => {
    signInToAmp(setIsAuthenticatedToBackend);
  }, [isAuthenticatedToBackend, setIsAuthenticatedToBackend]);

  const location = useLocation();

  React.useEffect(() => {
    analytics.page(location);
  }, [location]);

  return null;
};

export default UserAuthenticationState;
